import { FcDocument } from "react-icons/fc";
import { Box, Flex, Text, Link } from "@chakra-ui/react";
import type { WritingPublic } from "@/client";
import { SaveStatusPanel } from "@/components/Writings/SaveStatusPanel";

interface MetaHeaderProps {
  writing: WritingPublic;
  isSaving: boolean;
  isDirty: boolean;
  lastSavedTime: string | null;
  isSaveLoading: boolean;
}

export function MetaHeader({
  writing,
  isSaving,
  isDirty,
  lastSavedTime,
}: MetaHeaderProps) {
  return (
    <Flex height="100%" width="100%">
      {/* Fixed-width icon column */}
      <Box
        width="64px"
        bg="bg.option2"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Link href="/writings">
          <FcDocument size={56} style={{ cursor: "pointer" }} />
        </Link>
      </Box>

      {/* Title / Tags / Description */}
      <Flex direction="column" flex="1" minWidth="0" bg="bg.option2">
        {/* Title and Tags */}
        <Box height="56px" width="100%" bg="bg.option2">
          <Flex height="100%" gap={4} bg="bg.option2">
            <Box
              width="fit-content"
              maxWidth="300px"
              bg="bg.option2"
              display="flex"
              alignItems="flex-end"
              justifyContent="flex-start"
              px={4}
            >
              <Text fontSize="2xl" truncate>
                {writing.title}
              </Text>
            </Box>
            <Box
              flex="1"
              minWidth="0"
              bg="bg.option2"
              display="flex"
              alignItems="flex-end"
              justifyContent="flex-start"
              px={4}
            >
              <Text fontSize="xl" truncate>
                {/* Tag1 Tag2 Tag3 */}
              </Text>
            </Box>
          </Flex>
        </Box>

        {/* Description */}
        <Box
          height="44px"
          width="100%"
          bg="bg.option2"
          display="flex"
          alignItems="flex-start"
          justifyContent="flex-start"
          px={4}
        >
          <Text fontSize="lg" color="gray.400" truncate>
            {writing.description || "설명 없음"}
          </Text>
        </Box>
      </Flex>

      {/* Other stuff (fixed width) */}
      <Box
        width="300px"
        flexShrink={0}
        bg="bg.option2"
        display={{ base: "none", md: "flex" }}
        justifyContent="flex-end"
        alignItems="flex-end"
        pr={4}
      >
        <SaveStatusPanel
          isSaving={isSaving}
          isDirty={isDirty}
          lastSavedTime={lastSavedTime}
        />
      </Box>
    </Flex>
  );
}
